// src/utils/callSessionUtils.js

export function buildCallSessionsFromEnrollments(enrollments = [], { formatDuration, formatDate } = {}) {
  const flattened = [];
  for (const enrollment of enrollments) {
    const sessions = Array.isArray(enrollment.call_sessions) ? enrollment.call_sessions : [];
    sessions.forEach(cs => {
      const duration_display = formatDuration ? formatDuration(cs.duration_in_seconds) : cs.duration_in_seconds;
      const call_date_display = formatDate ? formatDate(cs.call_date) : cs.call_date;

      flattened.push({
        ...cs,
        patient: enrollment.patient,
        enrollment_id: enrollment.id,
        duration_display,
        call_date_display
      });
    });
  }
  return flattened.sort((a, b) => new Date(b.call_date) - new Date(a.call_date));
}

export function calculateCallSessionStats(callSessions) {
  const total = callSessions.length;
  const completed = callSessions.filter(cs => cs.status === 'success').length;
  const failed = callSessions.filter(cs => cs.status === 'failure').length;
  const initiated = callSessions.filter(cs => cs.status === 'initiated').length;
  const rescheduled = callSessions.filter(cs => cs.status === 'rescheduled').length;
  const unknown = callSessions.filter(cs => cs.status === 'unknown').length;

  return {
    total,
    completed,
    failed,
    initiated,
    rescheduled,
    unknown,
    successRate: total > 0 ? Math.round((completed / total) * 100) : 0
  };
}